import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RegisterButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.button.primary.background,
  color: theme.palette.button.primary.color,
  '&:hover': {
    backgroundColor: theme.palette.button.primary.backgroundHover,
  },
  height: '50px',
  width: '100%',
}));

export const CountryTypography = styled(Typography)({
  fontWeight: 'bold',
  color: 'gray',
  fontSize: '14px',
});

export const SuccessButton = styled(Button)(({ theme }) => ({
  marginTop: '15px',
  borderRadius: '4px',
  backgroundColor: theme.palette.dialog.primaryButton.background,
  color: theme.palette.dialog.primaryButton.color,
  '&:hover': {
    backgroundColor: theme.palette.dialog.primaryButton.backgroundHover,
  },
}));
